/* tslint:disable */
/* eslint-disable */
/**
 * Stututu API
 * REST API for the Stututu car community.
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { ListBazaarItems200ResponseDataInner } from './ListBazaarItems200ResponseDataInner';
import {
    ListBazaarItems200ResponseDataInnerFromJSON,
    ListBazaarItems200ResponseDataInnerFromJSONTyped,
    ListBazaarItems200ResponseDataInnerToJSON,
    ListBazaarItems200ResponseDataInnerToJSONTyped,
} from './ListBazaarItems200ResponseDataInner';

/**
 * 
 * @export
 * @interface ShowBazaarItem200Response
 */
export interface ShowBazaarItem200Response {
    /**
     * 
     * @type {ListBazaarItems200ResponseDataInner}
     * @memberof ShowBazaarItem200Response
     */
    data?: ListBazaarItems200ResponseDataInner;
}

/**
 * Check if a given object implements the ShowBazaarItem200Response interface.
 */
export function instanceOfShowBazaarItem200Response(value: object): value is ShowBazaarItem200Response {
    return true;
}

export function ShowBazaarItem200ResponseFromJSON(json: any): ShowBazaarItem200Response {
    return ShowBazaarItem200ResponseFromJSONTyped(json, false);
}

export function ShowBazaarItem200ResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): ShowBazaarItem200Response {
    if (json == null) {
        return json;
    }
    return {
        
        'data': json['data'] == null ? undefined : ListBazaarItems200ResponseDataInnerFromJSON(json['data']),
    };
}

export function ShowBazaarItem200ResponseToJSON(json: any): ShowBazaarItem200Response {
    return ShowBazaarItem200ResponseToJSONTyped(json, false);
}

export function ShowBazaarItem200ResponseToJSONTyped(value?: ShowBazaarItem200Response | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'data': ListBazaarItems200ResponseDataInnerToJSON(value['data']),
    };
}

